import { FC } from 'react';
import ProAvatar, { AvatarProps } from './avatar';
import ProAvatarGroup, { GroupProps } from './group';

export type ITabsComponent = FC<
  AvatarProps & React.RefAttributes<HTMLElement>
> & {
  Group: FC<GroupProps>;
};

const TransAvatar = ProAvatar as ITabsComponent;
TransAvatar.Group = ProAvatarGroup;

export default TransAvatar;
